import { prop } from "fw";

export class Icon {
    @prop(null) public name!: string;
    @prop(null) public ariaLabel?: string;
    @prop(null) public ariaHidden?: boolean;
    @prop("1em") public size: string;

    paths = {
        add: [
            "M 19.566406 10.5 L 13.5 10.5 L 13.5 4.433594 C 13.5 3.640625 12.828125 3 12 3 C 11.171875 3 10.5 3.640625 10.5 4.433594 L 10.5 10.5 L 4.433594 10.5 C 3.640625 10.5 3 11.171875 3 12 C 3 12.828125 3.640625 13.5 4.433594 13.5 L 10.5 13.5 L 10.5 19.566406 C 10.5 20.359375 11.171875 21 12 21 C 12.828125 21 13.5 20.359375 13.5 19.566406 L 13.5 13.5 L 19.566406 13.5 C 20.359375 13.5 21 12.828125 21 12 C 21 11.171875 20.359375 10.5 19.566406 10.5 Z M 19.566406 10.5 "
        ],
        copy: [
            "M 4 2 C 2.895 2 2 2.895 2 4 L 2 18 L 4 18 L 4 4 L 18 4 L 18 2 L 4 2 z M 8 6 C 6.895 6 6 6.895 6 8 L 6 20 C 6 21.105 6.895 22 8 22 L 20 22 C 21.105 22 22 21.105 22 20 L 22 8 C 22 6.895 21.105 6 20 6 L 8 6 z M 8 8 L 20 8 L 20 20 L 8 20 L 8 8 z"
        ],
        expand_more: ["M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"],
        expand_less: ["M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"],
        arrow_drop_up: ["M7 14l5-5 5 5z"],
        arrow_drop_down: ["M7 10l5 5 5-5z"],
        keyboard_arrow_left: ["M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"],
        keyboard_arrow_right: ["M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"],
        done: ["M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"],
        warning: ["M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"],
        notifications: [
            "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
        ],
        search: [
            "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        ],
        cancel: [
            "M12 1C6.47 1 2 5.47 2 11s4.47 10 10 10 10-4.47 10-10S17.53 1 12 1zm5 13.59L15.59 16 12 12.41 8.41 16 7 14.59 10.59 11 7 7.41 8.41 6 12 9.59 15.59 6 17 7.41 13.41 11 17 14.59z"
        ],
        tooltip: [
            "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
        ],
        clock: [
            "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
            "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        ],
        close: [
            "M 12.847656 12 L 19.925781 4.925781 C 20.160156 4.691406 20.160156 4.308594 19.925781 4.074219 C 19.691406 3.839844 19.308594 3.839844 19.074219 4.074219 L 12 11.152344 L 4.925781 4.074219 C 4.691406 3.839844 4.308594 3.839844 4.074219 4.074219 C 3.839844 4.308594 3.839844 4.691406 4.074219 4.925781 L 11.152344 12 L 4.074219 19.074219 C 3.839844 19.308594 3.839844 19.691406 4.074219 19.925781 C 4.191406 20.042969 4.347656 20.101562 4.5 20.101562 C 4.652344 20.101562 4.808594 20.042969 4.925781 19.925781 L 12 12.847656 L 19.074219 19.925781 C 19.191406 20.042969 19.347656 20.101562 19.5 20.101562 C 19.652344 20.101562 19.808594 20.042969 19.925781 19.925781 C 20.160156 19.691406 20.160156 19.308594 19.925781 19.074219 Z M 12.847656 12 "
        ],
        play: ["M8 5.14V19.14L19 12.14L8 5.14Z"],
        refresh: [
            "M 12,24 Q 6.975,24 3.4875,20.5125 0,17.025 0,12 0,6.975 3.4875,3.4875 6.975,0 12,0 14.5875,0 16.95,1.06875 19.3125,2.1375 21,4.125 V 0 h 3 V 10.5 H 13.5 v -3 h 6.3 Q 18.6,5.4 16.51875,4.2 14.4375,3 12,3 8.25,3 5.625,5.625 3,8.25 3,12 3,15.75 5.625,18.375 8.25,21 12,21 14.8875,21 17.2125,19.35 19.5375,17.7 20.475,15 h 3.15 Q 22.575,18.975 19.35,21.4875 16.125,24 12,24 Z"
        ],
        filter: [
            "M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6ZM12 18a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18ZM3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM5.25 18.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5ZM3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12ZM9 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM9 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"
        ]
    };

    public attached() {
        const hasHiddenValue: boolean = this.ariaHidden === false || this.ariaHidden === true;
        if (hasHiddenValue && this.ariaHidden && this.ariaLabel) {
            console.warn("aria-hidden and aria-label cannot both be set.");
        }
    }

    public get isHidden() {
        // if label is set then it defaults to false.
        if (this.ariaLabel) {
            return false;
        }

        const hasHiddenValue: boolean = this.ariaHidden === false || this.ariaHidden === true;
        return !hasHiddenValue || this.ariaHidden === true;
    }
}
